module.exports = __webpack_public_path__ + "img/eyes.8acf1dcb.svg";